var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-color-picker',_vm._b({attrs:{"show-alpha":"","colorFormat":"hex","predefine":_vm.predefine},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}},'el-color-picker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }